document.addEventListener('DOMContentLoaded', () => {
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  const stickyProductBar = document.querySelector('[data-sticky-product-bar]');
  const hasElement = (selector) => document.querySelector(selector);

  /* ═══════════════════════════════════
     1. Smooth scroll (Lenis)
     ═══════════════════════════════════ */
  let lenis = null;
  if (typeof Lenis !== 'undefined') {
    lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      touchMultiplier: 1.5
    });

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }

  /* ═══════════════════════════════════
     2. Ken Burns slideshow
     ═══════════════════════════════════ */
  const kbSlides = document.querySelectorAll('.hero-kb-slide');
  if (kbSlides.length > 1) {
    let kbCurrent = 0;
    setInterval(() => {
      const prev = kbSlides[kbCurrent];
      kbCurrent = (kbCurrent + 1) % kbSlides.length;
      const next = kbSlides[kbCurrent];

      /* Start next slide fading in while previous still visible */
      next.style.animation = 'none';
      next.offsetHeight;
      next.style.animation = '';
      next.classList.add('is-active');

      /* Fade out previous after crossfade overlap */
      setTimeout(() => {
        prev.classList.remove('is-active');
      }, 1500);
    }, 7000);
  }

  /* ═══════════════════════════════════
     3. Mobile menu toggle
     ═══════════════════════════════════ */
  if (mobileToggle && mobilePanel) {
    mobileToggle.addEventListener('click', () => {
      const expanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', String(!expanded));
      mobilePanel.hidden = expanded;
    });
  }

  /* ═══════════════════════════════════
     4. 3D Tilt on product cards
     ═══════════════════════════════════ */
  const isTouchDevice = 'ontouchstart' in window;
  if (!isTouchDevice) {
    document.querySelectorAll('[data-tilt]').forEach((card) => {
      const shine = document.createElement('div');
      shine.classList.add('tilt-shine');
      card.appendChild(shine);

      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = ((y - centerY) / centerY) * -6;
        const rotateY = ((x - centerX) / centerX) * 6;

        card.style.transform = `perspective(800px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02,1.02,1.02)`;
        card.style.setProperty('--mouse-x', `${(x / rect.width) * 100}%`);
        card.style.setProperty('--mouse-y', `${(y / rect.height) * 100}%`);
      });

      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
        card.style.transition = 'transform 0.5s cubic-bezier(0.33,1,0.68,1)';
        setTimeout(() => { card.style.transition = ''; }, 500);
      });
    });
  }

  /* ═══════════════════════════════════
     5. Magnetic buttons
     ═══════════════════════════════════ */
  if (!isTouchDevice) {
    document.querySelectorAll('[data-magnetic]').forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = `translate(${x * 0.25}px, ${y * 0.25}px)`;
      });

      btn.addEventListener('mouseleave', () => {
        btn.style.transform = '';
      });
    });
  }

  /* ═══════════════════════════════════
     6. Counter animation on stats
     ═══════════════════════════════════ */
  const counterEls = document.querySelectorAll('[data-counter]');
  if (counterEls.length) {
    const animateCounter = (el) => {
      const raw = el.dataset.counter;
      const prefix = raw.match(/^[^0-9]*/)[0];
      const suffix = raw.match(/[^0-9]*$/)[0];
      const numMatch = raw.match(/[0-9]+/);
      if (!numMatch) return;
      const target = parseInt(numMatch[0], 10);
      const duration = 2000;
      const start = performance.now();

      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = Math.round(target * eased);
        el.textContent = prefix + current + suffix;
        if (progress < 1) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    };

    const counterObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    counterEls.forEach((el) => counterObserver.observe(el));
  }

  /* ═══════════════════════════════════
     7. Sticky product bar
     ═══════════════════════════════════ */
  if (stickyProductBar) {
    const primaryButton = document.querySelector('[data-product-buy-button]');
    const variantSelect = document.querySelector('[data-product-variant-select]');
    const mainVariantInput = document.querySelector('[data-product-variant-input]');
    const stickyVariantInput = stickyProductBar.querySelector('[data-sticky-variant-input]');
    const stickyPrice = stickyProductBar.querySelector('[data-sticky-price]');

    if (primaryButton && stickyVariantInput) {
      let mainButtonVisible = true;

      const syncStickyVariant = () => {
        if (variantSelect) {
          const selectedOption = variantSelect.options[variantSelect.selectedIndex];
          stickyVariantInput.value = variantSelect.value;
          if (selectedOption && stickyPrice && selectedOption.dataset.price) {
            stickyPrice.innerHTML = selectedOption.dataset.price;
          }
          return;
        }
        if (mainVariantInput) {
          stickyVariantInput.value = mainVariantInput.value;
        }
      };

      const updateStickyBar = () => {
        const shouldShow = !mainButtonVisible && window.scrollY > 280;
        stickyProductBar.classList.toggle('is-visible', shouldShow);
        stickyProductBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };

      syncStickyVariant();
      if (variantSelect) {
        variantSelect.addEventListener('change', syncStickyVariant);
      }

      const buttonObserver = new IntersectionObserver(
        (entries) => {
          mainButtonVisible = entries[0].isIntersecting;
          updateStickyBar();
        },
        { threshold: 0.35 }
      );

      buttonObserver.observe(primaryButton);
      window.addEventListener('scroll', updateStickyBar, { passive: true });
      window.addEventListener('resize', updateStickyBar);
      updateStickyBar();
    }
  }

  /* ═══════════════════════════════════
     GSAP animations
     ═══════════════════════════════════ */
  if (typeof gsap === 'undefined') return;

  if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    /* Connect Lenis + ScrollTrigger */
    if (lenis) {
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add((time) => lenis.raf(time * 1000));
      gsap.ticker.lagSmoothing(0);
    }
  }

  const animateOnScroll = (triggerSelector, targetSelector, config) => {
    if (!hasElement(triggerSelector) || !hasElement(targetSelector)) return;
    const { start = 'top 80%', ...animationConfig } = config;
    gsap.from(targetSelector, {
      ...animationConfig,
      scrollTrigger: { trigger: triggerSelector, start }
    });
  };

  /* ── Hero text reveal ── */
  if (hasElement('#hero-section')) {
    const heroH1 = document.querySelector('#hero-section h1');
    if (heroH1) {
      const wrapWords = (el) => {
        const nodes = Array.from(el.childNodes);
        nodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const words = node.textContent.split(/(\s+)/);
            const frag = document.createDocumentFragment();
            words.forEach((word) => {
              if (/^\s*$/.test(word)) {
                frag.appendChild(document.createTextNode(word));
              } else {
                const outer = document.createElement('span');
                outer.className = 'hero-word';
                const inner = document.createElement('span');
                inner.className = 'hero-word-inner';
                inner.textContent = word;
                outer.appendChild(inner);
                frag.appendChild(outer);
              }
            });
            node.replaceWith(frag);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            wrapWords(node);
          }
        });
      };
      wrapWords(heroH1);
    }

    const heroTimeline = gsap.timeline({ defaults: { ease: 'power3.out', duration: 0.9 } });
    heroTimeline
      .from('#hero-section .hero-word-inner', {
        y: '110%',
        duration: 1,
        stagger: 0.04,
        ease: 'power4.out',
        delay: 0.3
      })
      .from('#hero-section [data-hero-copy]', { y: 24, opacity: 0 }, '-=0.5')
      .from('#hero-section [data-hero-actions]', { y: 20, opacity: 0 }, '-=0.4')
      .from('#hero-section [data-hero-features] > div', { opacity: 0, y: 10, stagger: 0.08 }, '-=0.3');
  }

  if (typeof ScrollTrigger === 'undefined') return;

  /* ── Parallax on sections ── */
  document.querySelectorAll('#hero-section, #expertise, #testimonials, #newsletter-section').forEach((section) => {
    const inner = section.querySelector('.section-shell') || section.firstElementChild;
    if (!inner) return;
    gsap.to(inner, {
      y: -40,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 0.8
      }
    });
  });

  /* ── Stats bar ── */
  animateOnScroll('#stats-bar', '#stats-bar .stats-item', {
    start: 'top 85%',
    scale: 0.92,
    opacity: 0,
    stagger: 0.15,
    duration: 0.8
  });

  /* ── Process steps ── */
  animateOnScroll('#process-steps', '#process-steps .process-card', {
    start: 'top 78%',
    y: 35,
    opacity: 0,
    stagger: 0.15,
    duration: 0.7
  });

  /* ── Expertise ── */
  if (hasElement('#expertise') && hasElement('#expertise [data-expertise-media]') && hasElement('#expertise [data-expertise-copy]')) {
    const expertiseTimeline = gsap.timeline({
      scrollTrigger: { trigger: '#expertise', start: 'top 70%' }
    });
    expertiseTimeline
      .from('#expertise [data-expertise-media]', { x: -40, opacity: 0, duration: 0.9 })
      .from('#expertise [data-expertise-copy] > *', { y: 24, opacity: 0, stagger: 0.12 }, '-=0.55');
  }

  /* ── Testimonials ── */
  animateOnScroll('#testimonials', '#testimonials .testimonial-card', {
    start: 'top 75%',
    scale: 0.96,
    opacity: 0,
    stagger: 0.18,
    duration: 0.75
  });

  /* ── Newsletter ── */
  animateOnScroll('#newsletter-section', '#newsletter-section .newsletter-panel', {
    start: 'top 85%',
    y: 30,
    opacity: 0,
    stagger: 0.2,
    duration: 0.8
  });

  /* ── Footer ── */
  animateOnScroll('footer', 'footer [data-footer-column]', {
    start: 'top 90%',
    y: 20,
    opacity: 0,
    stagger: 0.1,
    duration: 0.55
  });
});
